export const findDescendants = (children, parentId) => {
    const parents = children.filter((child) => child.parentId === parentId);
    return parents.flatMap((child) => [
        child,
        ...findDescendants(children, child.id),
    ]);
};

export const findIndeterminate = (children, checkedChildrenIds) => {
    const checkedSet = new Set(checkedChildrenIds);
    const indeterminateChildrenIds = new Set();

    function markIndeterminate(child) {
        if (!checkedSet.has(child.parentId)) {
            indeterminateChildrenIds.add(child.parentId);
            const parent = children.find((c) => c.id === child.parentId);
            if (parent) {
                markIndeterminate(parent);
            }
        }
    }

    children.forEach((child) => {
        if (checkedSet.has(child.id)) {
            markIndeterminate(child);
        }
    });

    return Array.from(indeterminateChildrenIds);
};
